// extracted by mini-css-extract-plugin
module.exports = {"root":"rubrique-landing-component_root__3gpyQ","newsContainer":"rubrique-landing-component_newsContainer__3cj0H","newsWrapper":"rubrique-landing-component_newsWrapper__2JFVH"};